import React from 'react'
import { FieldArray } from 'redux-form'
import ImagesUploader from './ImagesUploader'
import getFormValidations from "../apps/KpModule/components/Form/formValidations";
import ValidationUI from "./ValidationUI";


const arrayToObject = (array= []) =>
    array.reduce((obj, item) => {
        obj[item.id] = item
        return obj
    }, {})

const VisualComponent = ({fields:{ push, remove, move, getAll }, meta: { error }, t, tKey, fieldType, placeholder, user, editable}) => {
    const objects = getAll()
    const allIds = objects && objects.map(o => o.id)
    const byId = arrayToObject(objects)

    return (
        <div>
            <ImagesUploader
                byId={byId}
                allIds={allIds}
                push={push}
                remove={remove}
                move={move}
                user={user}
                editable={editable}
                placeholder={placeholder}
                tKey={tKey}
                fieldType={fieldType}
                t={t}
            />
            {error && <ValidationUI error={t(error)} />}
        </div>
    )
}

// binding for redux-form
const ImagesUploaderField = ({ field, module, user, t }) => {
    const validations = getFormValidations(field, t)
    return (
        <FieldArray
            name={field.path}
            tKey={field.tKey}
            fieldType={field.type}
            placeholder={field.placeholder}
            component={VisualComponent}
            module={module}
            validate={validations}
            rerenderOnEveryChange={true}
            user={user}
            editable={field.editable}
            t={t}
        />
    )
}


export default ImagesUploaderField
